import { Flex, omitProps, FlexProps } from '@qga/roo-ui/components';
import styled, { StyledComponent } from '@emotion/styled';
import { css } from '@emotion/core';

interface RowProps extends FlexProps {
  spacing: string | number;
}

const spacing = (props: RowProps & { theme: any }) => {
  const { spacing, theme } = props;
  const spacingPx = typeof spacing === 'number' ? theme.space[spacing] : spacing;
  return spacing
    ? css`
        margin-left: -${spacingPx};
        margin-right: -${spacingPx};
        & > * {
          padding-left: ${spacingPx};
          padding-right: ${spacingPx};
        }
      `
    : false;
};

const Row = styled(Flex, omitProps(['spacing']))`
  ${spacing}
` as StyledComponent<RowProps, RowProps, any>;

Row.displayName = 'Row';

Row.defaultProps = {
  ...Flex.defaultProps,
  flex: '1 1 auto',
  flexWrap: 'wrap',
  spacing: '10px',
};

export default Row;
